// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"155c9f4f","690":"30b712a0","703":"55b597f7","744":"beb3b522","787":"e2ff1f87","854":"fb905f11"}[chunkId] + ".chunk.js";
};